import SuspenseWrapper from '@src/components/suspenseWrapper';
import Loader from '@src/components/loader';
import lazyWithPreload from '@src/utils/lazyWithPreload';
import { RouteObject } from 'react-router-dom';
import { Path } from '../routes';
import Error from '@src/pages/error';
import Box from '@sendsprint/ui-react/dist/components/Box';
import { DashboardLayout, PlainLayout } from '@src/layouts';

export const SetupPage = lazyWithPreload(() => import('@src/pages/whiteLabel/setup'));
export const CustomiseProductPage = lazyWithPreload(
  () => import('@src/pages/whiteLabel/customiseProduct')
);

const routesData = [{ path: Path.WhiteLabelSetup, component: <SetupPage /> }];
const plainRoutesData = [
  { path: Path.WhiteLabelCustomiseProduct, component: <CustomiseProductPage /> }
];

export const whiteLabelChildrenRoutes: RouteObject[] = routesData.map(({ component, path }) => ({
  path,
  element: (
    <SuspenseWrapper
      errorFallback={({ resetError }) => (
        <Box className="">
          <Error resetError={resetError} />
        </Box>
      )}
      suspenseFallback={<Loader className="" showTimedOutScreen />}>
      {component}
    </SuspenseWrapper>
  )
}));

export const plainWhiteLabelRoutes: RouteObject[] = plainRoutesData.map(({ component, path }) => ({
  path,
  element: (
    <SuspenseWrapper
      errorFallback={({ resetError }) => (
        <Box className="">
          <Error resetError={resetError} />
        </Box>
      )}
      suspenseFallback={<Loader className="" showTimedOutScreen />}>
      {component}
    </SuspenseWrapper>
  )
}));

export const whiteLabelRoutes: RouteObject[] = [
  {
    element: <DashboardLayout client="white-label" setFixedMainWidth />,
    children: whiteLabelChildrenRoutes
  },
  {
    element: <PlainLayout />,
    children: plainWhiteLabelRoutes
  }
];
